module.exports = __webpack_public_path__ + "img/bg06.19ecc464.jpg";